import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import { instrumentMethod } from '../tools/instrumentMethod';
import { monitorError } from '../tools/monitor';
import { Observable } from '../tools/observable';
import { clocksNow } from '../tools/utils/timeUtils';
import { normalizeUrl } from '../tools/utils/urlPolyfill';
import { globalObject } from '../tools/globalObject';
import { readBytesFromStream } from '../tools/readBytesFromStream';
import { tryToClone } from '../tools/utils/responseUtils';
var fetchObservable;
var responseBodyActionGetters = [];
export function initFetchObservable() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      responseBodyAction = _ref.responseBodyAction;

  if (responseBodyAction) {
    responseBodyActionGetters.push(responseBodyAction);
  }

  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }

  return fetchObservable;
}
export function resetFetchObservable() {
  fetchObservable = undefined;
  responseBodyActionGetters.length = 0;
}

function createFetchObservable() {
  return new Observable(function (observable) {
    if (!globalObject.fetch) {
      return;
    }

    var _instrumentMethod = instrumentMethod(globalObject, 'fetch', function (call) {
      return beforeSend(call, observable);
    }, {
      computeHandlingStack: true
    }),
        stop = _instrumentMethod.stop;

    return stop;
  });
}

function beforeSend(_ref2, observable) {
  var parameters = _ref2.parameters,
      onPostCall = _ref2.onPostCall,
      handlingStack = _ref2.handlingStack;

  var _parameters = _slicedToArray(parameters, 2),
      input = _parameters[0],
      init = _parameters[1];

  var methodFromParams = init && init.method;

  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }

  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack
  };
  observable.notify(context); // Those properties can be changed by observable subscribers

  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    afterSend(observable, responsePromise, context)["catch"](monitorError);
  });
}

function afterSend(_x, _x2, _x3) {
  return _afterSend.apply(this, arguments);
}

function _afterSend() {
  _afterSend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(observable, responsePromise, startContext) {
    var _a, _b, context, response, responseBodyCondition, clonedResponse, bytes;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = startContext;
            context.state = 'resolve';
            _context.prev = 2;
            _context.next = 5;
            return responsePromise;

          case 5:
            response = _context.sent;
            _context.next = 15;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            context.status = 0;
            context.isAborted = ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || _context.t0 instanceof DOMException && _context.t0.code === DOMException.ABORT_ERR;
            context.error = _context.t0;
            observable.notify(context);
            return _context.abrupt("return");

          case 15:
            context.response = response;
            context.status = response.status;
            context.responseType = response.type;
            context.isAborted = false;
            responseBodyCondition = responseBodyActionGetters.reduce(function (action, getter) {
              return Math.max(action, getter(context));
            }, 0
            /* ResponseBodyAction.IGNORE */
            );

            if (!(responseBodyCondition !== 0
            /* ResponseBodyAction.IGNORE */
            )) {
              _context.next = 32;
              break;
            }

            clonedResponse = tryToClone(response);

            if (!(clonedResponse && clonedResponse.body)) {
              _context.next = 32;
              break;
            }

            _context.prev = 23;
            _context.next = 26;
            return readBytesFromStream(clonedResponse.body, {
              collectStreamBody: responseBodyCondition === 2
              /* ResponseBodyAction.COLLECT */

            });

          case 26:
            bytes = _context.sent;
            context.responseBody = bytes && new TextDecoder().decode(bytes);
            _context.next = 32;
            break;

          case 30:
            _context.prev = 30;
            _context.t1 = _context["catch"](23);

          case 32:
            observable.notify(context);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8], [23, 30]]);
  }));
  return _afterSend.apply(this, arguments);
}